export default "__VITE_ASSET__BdN$WgbD__"